// extracted by mini-css-extract-plugin
export var root = "fLmL";
export var rootHeader = "sKD1";
export var rootHeading = "d4Jw";
export var rootInfo = "NBW0";
export var rootInfoIcon = "dwGs";
export var rootInfoText = "uv8J";
export var rootNumberOfRatings = "inyd";
export var rootNumberOfRatingsNumber = "WIhr";
export var rootNumberOfRatingsTitle = "jZrT";
export var rootRating = "_41Zz";
export var rootRatingStars = "gk3k";
export var rootRatingStarsStar = "e+Wm";
export var rootRatingText = "ZMhL";
export var rootRatingTitle = "zDfb";
export var rootReviews = "GBIA";
export var rootSealLogo = "IGoi";
export var rootTile = "xzXA";
export var rootTiles = "ZuoM";